module.exports = __webpack_public_path__ + "img/86215f98f38542c8d348ce2eefa370fa.png";